import React from 'react';
import { ListDataInterface } from '@/types/components';

import { ListBlock } from '../List';

const TermsOfService = ({
  data,
}: {
  data: ListDataInterface[];
}): JSX.Element => {
  return (
    <ListBlock title="Terms of use" anschor="terms-of-service" data={data} />
  );
};

export default TermsOfService;
